import CheckinConditions from './components/CheckinConditions.css';

export default {
	CheckinConditions: CheckinConditions
};
